import React from 'react'

const Miscellaneous = () => {
    return (
        <div className='page-height'>
            Miscellaneous - COMING SOON
        </div>
    )
}

export default Miscellaneous